module.exports = __webpack_public_path__ + "static/img/25-北京市第十中学(新疆校区).a2f35a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/25-北京市第十中学(新疆校区).png
// module id = Q7Pa
// module chunks = 0